// Employee dropdown
export const FETCH_EMPLOYEE_LIST_REQUEST = "FETCH_EMPLOYEE_LIST_REQUEST";
export const FETCH_EMPLOYEE_LIST_SUCCESS = "FETCH_EMPLOYEE_LIST_SUCCESS";
export const FETCH_EMPLOYEE_LIST_FAILURE = "FETCH_EMPLOYEE_LIST_FAILURE";

// Leave Type
export const FETCH_LEAVE_TYPE_REQUEST = "FETCH_LEAVE_TYPE_REQUEST";
export const FETCH_LEAVE_TYPE_SUCCESS = "FETCH_LEAVE_TYPE_SUCCESS";
export const FETCH_LEAVE_TYPE_FAILURE = "FETCH_LEAVE_TYPE_FAILURE";

// Leave Balance
export const FETCH_LEAVE_BALANCE_REQUEST = "FETCH_LEAVE_BALANCE_REQUEST";
export const FETCH_LEAVE_BALANCE_SUCCESS = "FETCH_LEAVE_BALANCE_SUCCESS";
export const FETCH_LEAVE_BALANCE_FAILURE = "FETCH_LEAVE_BALANCE_FAILURE";

// Check Leave Exists
export const CHECK_LEAVE_EXISTS_REQUEST = "CHECK_LEAVE_EXISTS_REQUEST";
export const CHECK_LEAVE_EXISTS_SUCCESS = "CHECK_LEAVE_EXISTS_SUCCESS";
export const CHECK_LEAVE_EXISTS_FAILURE = "CHECK_LEAVE_EXISTS_FAILURE";

// Week of Dates
export const FETCH_WEEK_OF_DATES_REQUEST = "FETCH_WEEK_OF_DATES_REQUEST";
export const FETCH_WEEK_OF_DATES_SUCCESS = "FETCH_WEEK_OF_DATES_SUCCESS";
export const FETCH_WEEK_OF_DATES_FAILURE = "FETCH_WEEK_OF_DATES_FAILURE";

export const APPLY_TAB_REQUEST = "APPLY_TAB_REQUEST";
export const APPLY_TAB_SUCCESS = "APPLY_TAB_SUCCESS";
export const APPLY_TAB_FAILURE = "APPLY_TAB_FAILURE";

// Marker Pending List
export const FETCH_MARKER_PENDING_LIST_REQUEST = "FETCH_MARKER_PENDING_LIST_REQUEST";
export const FETCH_MARKER_PENDING_LIST_SUCCESS = "FETCH_MARKER_PENDING_LIST_SUCCESS";
export const FETCH_MARKER_PENDING_LIST_FAILURE = "FETCH_MARKER_PENDING_LIST_FAILURE";

// Marker Approve
export const MARKER_APPROVE_REQUEST = "MARKER_APPROVE_REQUEST";
export const MARKER_APPROVE_SUCCESS = "MARKER_APPROVE_SUCCESS";
export const MARKER_APPROVE_FAILURE = "MARKER_APPROVE_FAILURE";

// 🔹 Cancel List
export const FETCH_MARKER_CANCEL_LIST_REQUEST = "FETCH_MARKER_CANCEL_LIST_REQUEST";
export const FETCH_MARKER_CANCEL_LIST_SUCCESS = "FETCH_MARKER_CANCEL_LIST_SUCCESS";
export const FETCH_MARKER_CANCEL_LIST_FAILURE = "FETCH_MARKER_CANCEL_LIST_FAILURE";

// 🔹 Cancel Marker
export const MARKER_CANCEL_REQUEST = "MARKER_CANCEL_REQUEST";
export const MARKER_CANCEL_SUCCESS = "MARKER_CANCEL_SUCCESS";
export const MARKER_CANCEL_FAILURE = "MARKER_CANCEL_FAILURE";

// Absent List
export const FETCH_ABSENT_LIST_REQUEST = "FETCH_ABSENT_LIST_REQUEST";
export const FETCH_ABSENT_LIST_SUCCESS = "FETCH_ABSENT_LIST_SUCCESS";
export const FETCH_ABSENT_LIST_FAILURE = "FETCH_ABSENT_LIST_FAILURE";

// Absent LOP Update
export const ABSENT_LOP_UPDATE_REQUEST = "ABSENT_LOP_UPDATE_REQUEST";
export const ABSENT_LOP_UPDATE_SUCCESS = "ABSENT_LOP_UPDATE_SUCCESS";
export const ABSENT_LOP_UPDATE_FAILURE = "ABSENT_LOP_UPDATE_FAILURE";

// Absent Leave Update
export const ABSENT_LEAVE_UPDATE_REQUEST = "ABSENT_LEAVE_UPDATE_REQUEST";
export const ABSENT_LEAVE_UPDATE_SUCCESS = "ABSENT_LEAVE_UPDATE_SUCCESS";
export const ABSENT_LEAVE_UPDATE_FAILURE = "ABSENT_LEAVE_UPDATE_FAILURE";

// Absent OD Update
export const ABSENT_OD_UPDATE_REQUEST = "ABSENT_OD_UPDATE_REQUEST";
export const ABSENT_OD_UPDATE_SUCCESS = "ABSENT_OD_UPDATE_SUCCESS";
export const ABSENT_OD_UPDATE_FAILURE = "ABSENT_OD_UPDATE_FAILURE";

// Absent WeekOff Update
export const ABSENT_WEEKOFF_UPDATE_REQUEST = "ABSENT_WEEKOFF_UPDATE_REQUEST";
export const ABSENT_WEEKOFF_UPDATE_SUCCESS = "ABSENT_WEEKOFF_UPDATE_SUCCESS";
export const ABSENT_WEEKOFF_UPDATE_FAILURE = "ABSENT_WEEKOFF_UPDATE_FAILURE";

export const FETCH_EMPLOYEE_LEAVE_TYPE_REQUEST = "FETCH_EMPLOYEE_LEAVE_TYPE_REQUEST";
export const FETCH_EMPLOYEE_LEAVE_TYPE_SUCCESS = "FETCH_EMPLOYEE_LEAVE_TYPE_SUCCESS";
export const FETCH_EMPLOYEE_LEAVE_TYPE_FAILURE = "FETCH_EMPLOYEE_LEAVE_TYPE_FAILURE";

